export default __webpack_public_path__ + "static/media/CAKE.7d7f9ad0.png";